export default {
  methods: {
    /**
     *  From an object with different localized fields, get the one in the current locale.
     *  Example: { field_es: "Español", field_en: "English"}
     *
     *  @param data {Object} The origin to get the field from
     *  @param field {String} Field to get localized
     *  @return {String} Localized version of the field
     */
    $localized(data, field) {
      const locale = this.$i18n.locale.toLowerCase();
      let q = data[`${field}_${locale}`];

      if (!q) {
        const fallback = this.$i18n.fallbackLocale.toLowerCase();
        q = data[`${field}_${fallback}`];
      }

      return q;
    },
  },
};
